<mat-form-field class="example-full-width" appearance="outline">
  <mat-label>Характеристика</mat-label>
  <input matInput [formControl]="control" [matAutocomplete]="auto" />
  <mat-autocomplete
    #auto="matAutocomplete"
    [displayWith]="displayProperty"
    (optionSelected)="handleSelect($event)"
  >
    <mat-option *ngFor="let property of filteredOptions" [value]="property">
      {{ property.description }}
    </mat-option>
    <mat-option *ngIf="filteredOptions.length === 0" [value]="control.value">
      Создать {{ control.value }}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
